import styled from "styled-components";

export const SeccondModalButtons = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
`;

export const CloseIconContainer = styled.div`
  display: flex;
  position:absolute;
  top:-42px;
  left:auto;
  right:-10px;
  justify-content: flex-end;
  margin: 1rem 1rem 0 0;
  color:#ffffff;
  cursor:pointer;
`;

export const ModalContent = styled.div`
  background-color: white;

  @media (max-width: 769px) {
    text-align- center
  }
`;

export const Title = styled.h1`
  text-align: center;
  font: normal normal bold 25px/26px Roboto;
  letter-spacing: 0.48px;
  color: #000FFF;
`;

export const Caption = styled.h1`
  text-align: center;
  font: normal normal normal 16px/24px Roboto;
  letter-spacing: 0.38px;
  color: black;
`;

export const BodyContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;


export const ButtonLink = styled.div`
  font: normal normal 900 10px/19px Roboto;
  letter-spacing: 0.34px;
  color: #FFFFFF;
`;

export const ButtonArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;

export const Button = styled.div`
  width: 40%;
  height: 40px;
  margin-top: 15px;
  margin-left: 1px;
  background: #000FFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #0000004d;
  outline: none !important;
  border: 0;
  border-radius: 7px;
  cursor: pointer;
  transition: 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none !important;
  padding: 1px;
  color: #ffffff;
  &:hover {
    filter: brightness(90%);
  }
  span {
    color: #ffffff;
  }
  @media (max-width: 769px) {
    width: 100%;
  }
  @media (min-width: 855px) and (max-width: 975px) {
    font-size: 0.9rem;
  }
`;
